import { Box, Button, Text, useMediaQuery } from "@chakra-ui/react";
import { DateRangePicker } from "rsuite";
import { format } from "date-fns";
import React from "react";
import CommonCheckPicker from "../../CommonCheckPicker/CommonCheckPicker";


const FilterUserActivity = ({
  selectedUserName,
  setSelectedUserName,
  handleApplyFilters,
  handleResetFilters,
  userNameOptions,
  moduleOptions,
  selectedModules,
  setSelectedModules,
  setSearchMainDate,
  searchMainDate,
  fetchActionBreakdown,
  page,
  rowsPerPage,
  setActiveField,
  activeField,
}) => {
  const [isMedia] = useMediaQuery("(max-width: 800px)");

  const userData = userNameOptions.map((user) => ({
    label: `${user?.firstName} ${user?.lastName}`,
    value: `${user?._id}`,
  }));

  const moduleData = moduleOptions.map((module) => ({
    label: `${module}`,
    value: `${module}`,
  }));
  const [filterValue, setFilterValue] = React.useState(selectedUserName);
  const [filterDate, setFilterDate] = React.useState(searchMainDate);
  const [filterModule, setFilterModule] = React.useState(selectedModules);
  return (
    <>
      <Box
        display={["block", "block", "flex", "flex"]}
        justifyContent={"space-between"}
        width={"100%"}
        gap={10}
        paddingLeft={"10px"}
        mt={10}
        justifyItems={"center"}
      >
        <Box width={"100%"} gap={4}>
          <Text>User</Text>
          <CommonCheckPicker
            data={userData}
            value={filterValue.length > 0 ? filterValue : selectedUserName}
            placeholder="Select Users"
            onChange={(selectedOption) => {
              setFilterValue(selectedOption);
              setSelectedUserName(selectedOption);
              setActiveField({
                name: "username",
                value: selectedOption,
              });
            }}
            onClean={() => {
              fetchActionBreakdown({
                searchMainDate: filterDate,
                userName: [],
              })
              handleApplyFilters(page, rowsPerPage, "username", "");
              setSelectedUserName([]);
              setFilterValue([]);

              setActiveField({
                name: "username",
                value: "",
              });
            }}
          />
        </Box>
        <Box width={"100%"} gap={4}>
          <Text>Search Date</Text>
          <DateRangePicker
            style={{ width: "100%" }}
            placeholder="Select Date Range"
            format="dd.MM.yyyy"
            character=" – "
            menuClassName="reactDatePickerRange"
            value={filterDate.length > 0 ? filterDate : searchMainDate}
            placement="autoVertical"
            onClean={() => {
              fetchActionBreakdown({
                searchMainDate: "",
                userName: filterValue,
              })
              handleApplyFilters(page, rowsPerPage, "searchDate", "");
              setSearchMainDate([]);
              setFilterDate([]);
              setActiveField({
                name: "searchDate",
                value: "",
              });
            }}
            onChange={(value) => {
              const formattedDates =
                value && value.map((date) => format(date, "yyyy-MM-dd"));

              setFilterDate(value);
              setSearchMainDate(value);
              setActiveField({
                name: "searchDate",
                value: formattedDates,
              });
            }}
            showOneCalendar={!isMedia ? false : true}
          />
        </Box>
        <Box width={"100%"} gap={4}>
          <Text>Module</Text>
          <CommonCheckPicker
            data={moduleData}
            value={filterModule.length > 0 ? filterModule : selectedModules}
            placeholder="Select Modules"
            onChange={(selectedOption) => {
              setFilterModule(selectedOption);
              setSelectedModules(selectedOption);
              setActiveField({
                name: "module",
                value: selectedOption,
              });
            }}
            onClean={() => {
              fetchActionBreakdown({
                searchMainDate: filterDate.map((date) =>
                  format(date, "yyyy-MM-dd")
                ),
                userName: filterValue,
              })
              handleApplyFilters(page, rowsPerPage, "module", "");
              setSelectedModules([]);
              setFilterModule([]);
              setActiveField({
                name: "module",
                value: "",
              });
            }}
          />
        </Box>
        <Box width={"100%"} gap={4}>
          <Text>Action</Text>
          <Box display={"flex"} gap={3} borderRadius={"5px"}>
            <Button
              color={"#fff"}
              _hover={"none"}
              background={"#083c64"}
              onClick={() => {
                setSelectedUserName(filterValue);
                setSearchMainDate(filterDate);
                setSelectedModules(filterModule);
                fetchActionBreakdown({
                  searchMainDate: filterDate.map((date) =>
                    format(date, "yyyy-MM-dd")
                  ),
                  userName: filterValue,
                })
                handleApplyFilters(
                  0,
                  rowsPerPage,
                  activeField.name,
                  activeField.value
                );
              }}
            >
              Apply
            </Button>
            <Button
              color={"#fff"}
              _hover={"none"}
              background={"#083c64"}
              onClick={() => {
                setFilterValue([]);
                setFilterDate([]);
                setFilterModule([]);
                fetchActionBreakdown({
                  searchMainDate: [],
                  userName: [],
                })
                handleResetFilters();
              }}
            >
              Reset
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FilterUserActivity;